import { useContext } from "react";
import { ISRContext } from "../Context/ISRContext";

export const useISRContext = () => {
    return useContext(ISRContext);
};